import { jsxs, jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import "react";
import "react-i18next";
import "../shared/quiz-style-context.js";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../context/DevToolsContext.js";
import "../../../utils/quiz-parser.js";
import { getImageUrl, getPrintScale, PrintQuizTitle, PrintQuizProblem, PrintQuizImage, PRINT_CORRECT_ANSWER_CLASS, PrintOptionImage, getStyles } from "./print-common.js";
const CIRCLED_NUMBERS = ["①", "②", "③", "④", "⑤", "⑥", "⑦", "⑧", "⑨", "⑩"];
function MultiChoicePrint({
  quizId,
  quiz,
  number,
  showCorrectAnswers = false,
  correctAnswers,
  compact
}) {
  const s = getStyles(compact);
  const imageUrl = getImageUrl(quiz.image, quiz.imagePrint);
  const printScale = getPrintScale(quiz.image, quiz.imagePrint);
  const subtype = quiz.subtype;
  const isHorizontalChoiceRow = subtype === "C";
  const sortedAnswers = quiz.random && Array.isArray(quiz.random) && quiz.random.length > 0 ? quiz.random.map((idx) => quiz.choices[idx]).filter(Boolean) : quiz.choices;
  const correctKeys = new Set(quiz.choices.filter((c) => c.correct).map((c) => c.key));
  const choiceKeys = new Set(quiz.choices.map((choice) => choice.key));
  for (const correctAnswer of correctAnswers ?? []) {
    if (choiceKeys.has(correctAnswer)) {
      correctKeys.add(correctAnswer);
      continue;
    }
    const choiceIndex = Number(correctAnswer);
    if (Number.isInteger(choiceIndex) && choiceIndex >= 1 && choiceIndex <= quiz.choices.length) {
      correctKeys.add(quiz.choices[choiceIndex - 1].key);
    }
  }
  return /* @__PURE__ */ jsxs("div", { className: cn(s.container, s.quizSection), children: [
    /* @__PURE__ */ jsx(PrintQuizTitle, { number, compact, children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
    /* @__PURE__ */ jsx(
      PrintQuizProblem,
      {
        problem: quiz.problem,
        quizId,
        additionalImages: quiz.additionalImages,
        compact
      }
    ),
    imageUrl && /* @__PURE__ */ jsx(PrintQuizImage, { src: imageUrl, printScale }),
    /* @__PURE__ */ jsx(
      "div",
      {
        "data-testid": "print-multi-choice-options",
        className: cn(
          "w-full",
          compact ? "px-[34px]" : "px-[40px]",
          subtype === "B" && (compact ? "grid grid-cols-2 gap-[4px]" : "grid grid-cols-2 gap-[12px]"),
          isHorizontalChoiceRow && "flex flex-nowrap items-center justify-between",
          !isHorizontalChoiceRow && (!subtype || subtype !== "B") && (compact ? "flex flex-col gap-[8px]" : "flex flex-col gap-[12px]")
        ),
        children: sortedAnswers.map((answer, idx) => {
          const isCorrect = correctKeys.has(answer.key);
          const checked = showCorrectAnswers && isCorrect;
          const choiceImageUrl = getImageUrl(answer.image);
          return /* @__PURE__ */ jsxs(
            "div",
            {
              "data-testid": "print-multi-choice-option",
              className: cn(
                "flex min-w-0 items-center gap-[8px]",
                checked && PRINT_CORRECT_ANSWER_CLASS
              ),
              children: [
                /* @__PURE__ */ jsx("span", { className: cn(
                  compact ? "text-[18px]" : "text-[20px]",
                  "font-light shrink-0",
                  checked ? PRINT_CORRECT_ANSWER_CLASS : "text-black"
                ), children: CIRCLED_NUMBERS[idx] || `${idx + 1}` }),
                choiceImageUrl && /* @__PURE__ */ jsx(PrintOptionImage, { src: choiceImageUrl, alt: `option-${idx + 1}` }),
                answer.answer && /* @__PURE__ */ jsx("span", { className: cn(
                  compact ? "text-[15px] tracking-[-0.09px]" : "text-[16px] tracking-[-0.096px]",
                  "leading-[30px]",
                  checked ? PRINT_CORRECT_ANSWER_CLASS : "text-black"
                ), children: /* @__PURE__ */ jsx(KatexText, { text: answer.answer }) })
              ]
            },
            answer.key
          );
        })
      }
    )
  ] });
}
export {
  MultiChoicePrint
};
//# sourceMappingURL=multi-choice-print.js.map
